import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useData } from '../hooks/useData';

const ToolsPage = () => {
  const { data: toolsData, loading, error } = useData('tools.json');

  if (loading) return <div className="container mx-auto p-4 text-center">Loading AI tools...</div>;
  if (error) return <div className="container mx-auto p-4 text-center text-red-500">Error loading AI tools: {error}</div>;
  if (!toolsData || !toolsData.tools) return <div className="container mx-auto p-4 text-center">No AI tools found.</div>;

  const tools = toolsData.tools;

  return (
    <>
      <Helmet>
        <title>AI Tools - AI News</title>
        <meta name="description" content="Discover the latest AI tools, frameworks, libraries, and APIs for developers." />
        <meta name="keywords" content="AI tools, AI frameworks, AI libraries, AI APIs, machine learning tools" />
      </Helmet>
      <div className="container mx-auto p-4">
        <header className="my-8 text-center">
          <h1 className="text-4xl font-bold text-gray-100">AI Tools</h1>
          <p className="text-lg text-gray-300 mt-2">Find the best tools to accelerate your AI development.</p>
        </header>

        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tools.map((tool) => (
            <article key={tool.id} className="card hover:shadow-xl transition-shadow">
              <div className="mb-4">
                <span className="text-secondary-blue font-semibold">{tool.category}</span>
                <span className="text-gray-400 ml-2">v{tool.version}</span>
              </div>
              <h2 className="text-xl font-bold mb-2 text-gray-100">{tool.name}</h2>
              <p className="text-gray-300 mb-4 text-sm">{tool.description}</p>
              <Link
                to={`/tools/${tool.slug}`}
                className="text-secondary-blue font-semibold hover:underline text-sm"
              >
                Learn More →
              </Link>
            </article>
          ))}
        </section>
      </div>
    </>
  );
};

export default ToolsPage; 